export default "__VITE_ASSET__Brkx_5_$__"